import firebase from 'firebase';
import 'firebase/database';

const firebaseConfig = {
    apiKey: "AIzaSyBJ64VQc-dbYGFUuwFn5mAzv_mbX4B-esk",
    authDomain: "aglocol.firebaseapp.com",
    databaseURL: "https://aglocol.firebaseio.com",
    projectId: "aglocol",
    storageBucket: "aglocol.appspot.com",
    messagingSenderId: "786852294718",
    appId: "1:786852294718:web:f20d705f0cda737ac7e16f",
    measurementId: "G-HV4GY2J8XX"
};
const app = firebase.initializeApp(firebaseConfig);
firebase.analytics();

const db = app.database();

export {
    db
}